import Vue from 'vue'
import VueAuth from '@websanova/vue-auth'

import UserModel from '@/services/Models/UserModel'

Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  notFoundRedirect: {path: '/feed'},
  registerData: {url: 'register', method: 'POST', redirect: null},
  refreshData: {enabled: false},
  fetchData: {url: 'me', method: 'GET', enabled: true},
  loginData: {url: 'login', method: 'POST', redirect: '/feed', fetchUser: true},
  logoutData: {url: 'logout', method: 'POST', redirect: '/login', makeRequest: false},
  parseUserData(data) {
    data = UserModel(data)

    return data
  }
})



// WEBPACK FOOTER //
// ./src/config/auth.js